/* eslint-disable import/prefer-default-export */
export const getSortingIconValues = ({ sorting, type }) => {
  if (sorting.type === type) {
    return {
      color: 'primary',
      type: sorting.order === 'asc' ? 'ascending' : 'descending',
    };
  }

  return {
    color: 'gray-primary',
    type: 'ascending',
  };
};
